import { h, Component } from 'preact';
import style from './style.css';
import common from '../../../common/common';
import { locale } from '../../../utils/i18n';
import { postMessageOnParentWindow } from '../../../common/postMessage';

export default class Error extends Component {
  constructor(props) {
    super(props);
    this.retry = this.retry.bind(this);
    this.state = {
      errorMSG: (props.appData && props.appData.errorMSG) || 'Oops! Something went wrong'
    };
  }

  retry() {
    if (this.props && this.props.appData) {
      common.log('onRetryClick', 'Retry Button');
      postMessageOnParentWindow(this.props.appData);
    }
  }

  render({ appData }, { errorMSG }) {
    return (
      <div class="wrapper">
        <h2 class="main-heading heading-trim">{locale('checkout.title')}</h2>
        <div className={`${style['error-page-wrap']}`}>
          <img
            className={`${style['error-img']}`}
            src={`${common.getStaticPath()}/assets/images/not-found.svg`}
            alt=""
          />
          <h2 className={`${style['error-heading']}`}>
            {(appData && appData.body && appData.body.resultInfo && appData.body.resultInfo.resultMsg) || errorMSG}
          </h2>
          {/* <p className={`${style['error-para']}`}>Neque porro quisquam est qui dolorem ipsum quia dolor</p> */}
          {appData && appData.body && appData.body.resultInfo && appData.body.resultInfo.resultCode == '449' && (
            <button className={`${style['retry-btn']} btn btn-primary`} onClick={this.retry}>
              Retry
            </button>
          )}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./checkout/components/error/index.js